import Vue from "vue"
import Table from "./m-table"
import Paginator from "./m-paginator"

document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("companiesList")) {
    return
  }
  window.companiesList = new Vue({
    el: "#companiesList",
    components: { "m-table": Table, "m-paginator": Paginator },
    data: {
      head: window.manager.data.head,
      items: window.manager.data.items,
      currentPage: window.manager.data.currentPage,
      totalPages: window.manager.data.totalPages,
      search: "",
    },
    watch: {
      search(value) {
        const url = `${window.location}?search=${encodeURI(value)}`
        fetch(url, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.DATA) {
              this.items = data.DATA.items
            }
          })
      },
    },
    methods: {
      changePage(page) {
        this.current = page
        const url = `${window.location}?page=${encodeURI(page)}`
        fetch(url, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.DATA) {
              this.items = data.DATA.items
              this.currentPage = data.DATA.currentPage
              this.totalPages = data.DATA.totalPages
              this.$refs.paginator.buildChain()
            }
          })
      },
    },
  })
})
